import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import cn from 'classnames';
import 'react-simple-keyboard/build/css/index.css';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import { getObjectValue, deconstructStringUrl, replaceAll } from '@utility/utills';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { flowType } from '@utility/userInfo';
import style from '@components/Loyalty/loyaltyCopy.module.scss';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import LoyaltyLightImg from '@assets/images/loyaltyLight.png';
import LoyaltyImg from '@assets/images/loyalty.png';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import PropTypes from 'prop-types';

const OrderLoyaltyHeader = React.memo(({ isLandScape, name, loyaltyMethod, themeProperties, getTheme, serverAppTheme }) => {
  if (isLandScape) return null;
  return (
    <>
      <div
        className={cn("w-100 pt-2", name !== 'Email' && "pb-1 h-20")}
        style={{
          height: name === 'Email' && "138px"
        }}
      >
        {(loyaltyMethod === 'signIn' ? themeProperties?.loyaltySignInImageUrl?.length > 0 : themeProperties?.loyaltySignUpImageUrl?.length > 0) ?
          <img src={loyaltyMethod === 'signIn' ? themeProperties?.loyaltySignInImageUrl : themeProperties?.loyaltySignUpImageUrl} alt="" className={cn('w-100 h-100')} style={{ objectFit: 'cover' }} />
          :
          (getTheme === '2') ? <img src={LoyaltyLightImg} style={{ width: '100%', objectFit: 'cover' }} className='h-100' alt='loyaltyLightImg' /> : <img src={LoyaltyImg} style={{ width: '100%', objectFit: 'cover' }} className='h-100' alt='loyaltyImg' />}
      </div>
      <div className='text-center py-1 fw-600 fs_28' style={{ fontFamily: 'Poppins', color: serverAppTheme?.primary_text }}>{loyaltyMethod === 'signIn' ? LABEL().OLS_SIGN_IN : LABEL().OLS_SIGN_UP}</div>
    </>
  );
});

const LoyaltyInputModule = React.memo(({ 
  name, placeHolder, countryCode, handleCountryCodeChange, serverAppTheme, isLandScape, isServerApp, isKiosk, onValueChange, error, storeInfo, emailDomainNames
}) => {
  const [swipedDown, setSwipedDown] = useState(true);
  const [inputName, setInputName] = useState(`${name}`);
  const [inputs, setInputs] = useState({});
  const [typed, setTyped] = useState({});
  const [keyboardType, setKeyboardType] = useState(name === 'Email' ? 'textWithNumericEmail' : 'numericWithBin');
  
  const inputNameRef = useRef(inputName);
  inputNameRef.current = inputName;
  const countryCodeRef = useRef(countryCode);
  countryCodeRef.current = countryCode;

  const handleBlur = () => {
    setSwipedDown(true);
    const element = document.querySelector(`#${name}`);
    if (element) element.blur();
  };

  const getInputValue = (nameDat) => inputs[nameDat] || '';

  const onChangeInput = (event) => {
    setInputName(`${name}`);
    setSwipedDown(true);
  };

  const onClickBtn = useCallback((e) => {
    const currentInputName = inputNameRef.current;
    const currentCountryCode = countryCodeRef.current;
    setTyped(prev => {
      const prevVal = prev[currentInputName] || '';

      if (e === '{bksp}' && prevVal.length === 0) {
        return prev;
      }

      const rawNewValue = e === '{bksp}' ? prevVal.slice(0, -1) : prevVal.concat(e);

      const limit = currentInputName === 'PhoneNumber' ? (Number(currentCountryCode) === 1 ? 10 : 15) : 0;
      if (Number(limit) > 0 && e !== '{bksp}' && rawNewValue.length > Number(limit)) {
        return prev;
      }

      const formattedValue = currentInputName === 'PhoneNumber' && Number(currentCountryCode) === 1
        ? getFormatedPhoneNumber(rawNewValue)
        : rawNewValue;
      
      setInputs(inp => {
        const nextInp = { ...inp, [currentInputName]: formattedValue };
        onValueChange(formattedValue);
        return nextInp;
      });
      return { ...prev, [currentInputName]: rawNewValue };
    });
  }, [onValueChange]);

  const handleClear = useCallback(() => {
    const currentInputName = inputNameRef.current;
    setTyped(prev => ({ ...prev, [currentInputName]: '' }));
    setInputs(prev => ({ ...prev, [currentInputName]: '' }));
    onValueChange('');
  }, [onValueChange]);

  const handleSetInputEmpty = useCallback(() => handleClear(), [handleClear]);
  const closeKeyboard = useCallback(() => setSwipedDown(false), []);

  const handleDomainSelect = useCallback((domain) => {
    const currentInputName = inputNameRef.current;
    setInputs(prev => {
      const prefix = (prev[currentInputName] || '').split('@')[0];
      const updatedEmail = `${prefix}${domain}`;
      setTyped(t => ({ ...t, [currentInputName]: updatedEmail }));
      onValueChange(updatedEmail);
      return { ...prev, [currentInputName]: updatedEmail };
    });
  }, [onValueChange]);

  const btnSizeClass = useMemo(() => (keyboardType === 'emailText') ? 'btn' : 'btn35 py-2', [keyboardType]);
  const keyboardCustomClass = useMemo(() => cn(`fs-30 border-0`, keyboardType === 'textWithoutNumeric' ? 'pl-1 pt-2' : 'pl-1'), [keyboardType]);
  const returnMaxLength = () => (Number(countryCode) === 1 ? 10 : 15);
  const maxLength = useMemo(() => inputName === 'PhoneNumber' ? returnMaxLength() : undefined, [inputName, countryCode]);

  return (
    <>
      <div className={cn(style.overlay, "col-12 py-1", isLandScape ? 'px-3 mt-2 d-flex justify-content-center' : 'px-0 position-relative', name === 'Email' ? isLandScape ? 'h-10' : "h-8" : "h-10")}>
        {name === 'PhoneNumber' && (
          <PhoneNumberComponent
            countryCode={countryCode}
            styles={{ top: 0, left: isLandScape ? '17%' : 0, padding: isLandScape ? 'p-0' : 'p-2', width: 'w-30 !important' }}
            isCustomWidth="w-35 fs-20"
            handleCountryCodeChange={(e) => { handleCountryCodeChange(e); handleClear(); }}
            maxMenuHeight={200}
            screenType={'orderLoyalty'}
            serverAppTheme={serverAppTheme}
          />
        )}
        <input
          id={name}
          type="emailText"
          className={cn(isLandScape ? 'col-8' : 'col-12', 'form-control h-100', name === 'PhoneNumber' ? 'pt-2' : 'text-left', style.inputBg)}
          style={{ fontSize: isServerApp ? "24px" : "20px", paddingLeft: name === 'PhoneNumber' && '9.2rem', background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder }}
          placeholder={placeHolder}
          value={getInputValue(`${name}`)}
          onFocus={(e) => { handleBlur(); onChangeInput(e); setKeyboardType(name === 'PhoneNumber' || name === 'AccountNumber' ? 'numericWithBin' : 'textWithNumericEmail'); }}
          onChange={onChangeInput}
        />
        {getInputValue(`${name}`) && (
          <TouchableDiv role="presentation" className="position-absolute h-100" style={{ top: '18%', right: isLandScape ? '19%' : '1%' }} onClick={handleClear}>
            <Cross fill={serverAppTheme?.iconcolor} />
          </TouchableDiv>
        )}
      </div>
 <div className={cn(isLandScape && 'col-10',"fs-14 text-primary text-right h-3", name !== "Email" && isLandScape ? "h-4" : name !== "Email" ? "pt-1" : '')}>{error.length > 0 && error}</div>
      <div className={cn(error ? 'h-59' : (name !== 'Email' && isLandScape ? storeInfo?.loyaltyInfo?.loyaltyDisclaimer ? 'h-63' : 'h-74' : ''))}>
        {swipedDown && (
          <div>
          <CustomKeyboard
            setKeyboardType={setKeyboardType}
            onClickBtn={onClickBtn}
            type={keyboardType}
            closeKeyboard={closeKeyboard}
            btnSize={btnSizeClass}
            isDot
            isDone
            customClass={keyboardCustomClass}
            maxLength={maxLength}
            typed={typed[inputName] || ''}
            spacebtn={style.spacebtn}
            setinputEmpty={handleSetInputEmpty}
            screenType={'loyalty'}
          />
          </div>
        )}
      </div>

      {!isLandScape && name === 'Email' && emailDomainNames?.length > 0 && (
        <div className={cn('d-flex flex-wrap o-group-menu w-100 align-items-center pt-3 pb-2')}>
          {emailDomainNames.map((domain) => (
            <button
              key={domain}
              className={cn(style.oUnselectedGroupBg, 'd-inline-flex text-nowrap px-3 fs_16 fw-500 rounded-pill py-1 mr-2 mb-2')}
              type="button"
              onClick={() => handleDomainSelect(domain)}
              style={{ color: serverAppTheme?.primary_text, border: `1px solid ${serverAppTheme?.modifiers_border}`, background: "none" }}
            >
              {domain}
            </button>
          ))}
        </div>
      )}
    </>
  );
});

const OrderLoyaltyFooter = React.memo(({ 
  isLandScape, error, storeInfo, isLoyaltyBalance, termsAccepted, setTermsAccepted, serverAppTheme, disclamer, handleCancel, handleOrderBackButton, handleSubmit, lookupMethods, name
}) => {
  return (
    <>
      {(storeInfo?.loyaltyInfo?.loyaltyDisclaimer && !isLoyaltyBalance) && (
        <TouchableDiv className={cn("row display-flex flex-direction-row mx-0  align-items-center text-white", (name === 'Email' && isLandScape) || (name === 'PhoneNumber' && isLandScape)
        ? "px-3 py-3 justify-content-center"
        : name === 'Email'
        ? ""
        : "h-10", !isLandScape && name === 'PhoneNumber' && 'pt-4',)}>
          <input className={style.checkbox} type="checkbox" name="disclaimer" style={{ height: "22px", width: "22px", marginBottom: !isLandScape && '1.5%', zIndex: '999', border: !termsAccepted && serverAppTheme?.checkbox_border, '--checkbox-checked-color': '#fff' }} checked={termsAccepted} onChange={(e) => { setTermsAccepted(e.target.checked); }} />
          <div className={cn(isLandScape ? 'col-8' : 'col-11',"px-2 d-inline flex-wrap fs_12 fw-400 text-left")} style={{ color: serverAppTheme?.secondary_text }}>
            {disclamer?.length > 0 && disclamer?.map((text, idx) => {
              return text.startsWith('#?') ? (
                <span key={idx} role="presentation" className="text white">{text.replace('#?', '')}</span>
              ) : (
                <React.Fragment key={idx}>{text}</React.Fragment>
              );
            })}
          </div>
        </TouchableDiv>
      )}

      <div className={cn('h-10', isLandScape ? 'px-3 pb-3 col-12 d-flex justify-content-center align-items-center' : 'w-95 px-0 d-flex position-absolute')} style={{ bottom: !isLandScape ? '16px' : 0 }}>
        <div className={cn("h-100 d-flex align-items-end", isLandScape ? 'col-5 pl-0 pr-1' : 'col-6 pl-0 pr-2')}>
          <TouchableButton
            type="button"
            className={cn("col-12 px-0 d-flex justify-content-center align-items-center od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color", style.loyalty_btn)}
            style={{ height: "7.5vh", backgroundColor: serverAppTheme?.OFF_Premise_Btn, color: serverAppTheme?.primary_text, border: "1px solid #2541A4" }}
            onClick={(e) => { e.preventDefault(); isLoyaltyBalance && lookupMethods ? handleCancel() : handleOrderBackButton(); }}
            rippleEffect={true}
          >
            <span className="fw-600 fs_28">{LABEL().OLS_CANCEL}</span>
          </TouchableButton>
        </div>
        <div className={cn('h-100 d-flex align-items-end', isLandScape ? 'col-5 pr-0 pl-1' : 'col-6 pl-1 pr-1')}>
          <TouchableButton
            type="button"
            className={cn('col-12 px-0 btn-ripple d-flex justify-content-center align-items-center od-primary-btn-bg-color od-primary-btn-font-color', style.loyalty_btn)}
            style={{ height: '7.5vh' }}
            onClick={(e) => { e.preventDefault(); handleSubmit(); }}
            rippleEffect={true}
          >
            <span className="fw-600 fs_28">{LABEL().OLS_CONTINUE}</span>
          </TouchableButton>
        </div>
      </div>
    </>
  );
});

const OrderLoyaltyKeyboard = ({
  name, handleLoyaltySubmit, placeHolder,
  countryCode, handleCountryCodeChange, loyaltyMethod, handleOrderBackButton, serverAppTheme, handleLoyaltyInfo, isLoyaltyBalance,
  themeProperties, lookupMethods, handleCancel, isLandScape, setErrorPopUp
}) => {
  const [error, setError] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [disclamer, setDisclamer] = useState([]);
  const inputValueRef = useRef('');

  const onValueChange = useCallback((val) => {
    inputValueRef.current = val;
  }, []);

  const authInfo = useMemo(() => getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')), {}), []);
  const storeInfo = authInfo;
  const getTheme = authInfo?.serverAppTheme;

  useEffect(() => {
    const d = storeInfo?.loyaltyInfo?.loyaltyDisclaimer || '';
    if (d?.length > 0) {
      const [, concatChar] = deconstructStringUrl(d);
      setDisclamer(concatChar.split('¿'));
    }
  }, [storeInfo]);

  const handleSubmit = useCallback(() => {
    const val = replaceAll(inputValueRef.current || '', '-');
    if (!val) {
      setErrorPopUp({ res: name === 'PhoneNumber' ? CUSTOM_MESSAGES().OLS_NUMBER_FIELD_REQUIRED : CUSTOM_MESSAGES().OLS_EMAIL_FIELD_REQUIRED, noErrorTxt: true });
      return;
    } else if (countryCode === '1' && val.length < 10 && name === 'PhoneNumber') {
      setErrorPopUp({ res: CUSTOM_MESSAGES().OLS_NUMBER_DEGIT_ERROR, noErrorTxt: true });
      return;
    } else if (name === 'Email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
      setErrorPopUp({ res: CUSTOM_MESSAGES().OLS_EMAIL_INVALID, noErrorTxt: true });
      return;
    } else if (!termsAccepted && storeInfo?.loyaltyInfo?.loyaltyDisclaimer && !isLoyaltyBalance) {
      setErrorPopUp({ res: CUSTOM_MESSAGES().OLS_PLEASE_AGREE_TERMS, noErrorTxt: true });
      return;
    }
    handleLoyaltySubmit(val, name, termsAccepted);
  }, [name, countryCode, setErrorPopUp, termsAccepted, storeInfo, isLoyaltyBalance, handleLoyaltySubmit]);

  const isServerApp = flowType() === 'serverApp';
  const isKiosk = flowType() === 'kiosk';

  return (
    <div className={cn("h-100 w-100")}>
      <OrderLoyaltyHeader 
        isLandScape={isLandScape} 
        name={name} 
        loyaltyMethod={loyaltyMethod} 
        themeProperties={themeProperties} 
        getTheme={getTheme} 
        serverAppTheme={serverAppTheme} 
      />

      <LoyaltyInputModule
        name={name}
        placeHolder={placeHolder}
        countryCode={countryCode}
        handleCountryCodeChange={handleCountryCodeChange}
        serverAppTheme={serverAppTheme}
        isLandScape={isLandScape}
        isServerApp={isServerApp}
        isKiosk={isKiosk}
        onValueChange={onValueChange}
        error={error}
        storeInfo={storeInfo}
        emailDomainNames={storeInfo?.emailDomainNames}
      />

      <OrderLoyaltyFooter 
        isLandScape={isLandScape}
        error={error}
        storeInfo={storeInfo}
        isLoyaltyBalance={isLoyaltyBalance}
        termsAccepted={termsAccepted}
        setTermsAccepted={setTermsAccepted}
        serverAppTheme={serverAppTheme}
        disclamer={disclamer}
        handleCancel={handleCancel}
        handleOrderBackButton={handleOrderBackButton}
        handleSubmit={handleSubmit}
        lookupMethods={lookupMethods}
        name={name}
      />
    </div>
  );
};

OrderLoyaltyKeyboard.propTypes = {
  name: PropTypes.string,
  handleLoyaltySubmit: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  countryCode: PropTypes.string,
  handleCountryCodeChange: PropTypes.func,
  loyaltyMethod: PropTypes.string,
  handleOrderBackButton: PropTypes.func,
  serverAppTheme: PropTypes.string,
  handleLoyaltyInfo: PropTypes.func,
  isLoyaltyBalance: PropTypes.bool,
  themeProperties: PropTypes.object,
  lookupMethods: PropTypes.array,
  handleCancel: PropTypes.func,
  isLandScape: PropTypes.bool,
  setErrorPopUp: PropTypes.func,
};

OrderLoyaltyKeyboard.defaultProps = {
  name: '',
  placeHolder: '',
  countryCode: '',
  loyaltyMethod: '',
  isLoyaltyBalance: false,
  isLandScape: false,
  lookupMethods: [],
  themeProperties: {},
};

export default React.memo(OrderLoyaltyKeyboard);
